import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { AuthState } from '../store/auth/types';

export default function useSessionLoading() {
  const { sessionLoading } = useSelector<RootState, AuthState>((state) => state.authState);
  return sessionLoading;
}
